import styled from "styled-components";

export const DocumentsContainer = styled.div`
  //margin-top: 1.5rem;
  padding: 1.25rem;
  border-radius: 14px;

  background: var(--surface-overlay);
  border: 1px solid var(--border-subtle);
`;


export const DocumentItem = styled.div`
  padding: 0.75rem 1rem;
  border-radius: 10px;
  width: 95%;
  background: var(--surface-glass);
  border: 1px solid var(--border-subtle);

  margin-bottom: 0.5rem;
`;

export const DocumentLinkContainer = styled.div`
width: 50%;
`;

export const DocumentLink = styled.div`
  cursor: pointer;
  color: var(--info);
  font-size: 0.63rem;
  line-height: 1.3;

  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;

  overflow: hidden;
  text-overflow: ellipsis;

  &:hover {
    display: block;
    white-space: normal;
    overflow: visible;
    text-decoration: underline;
  }
`;

export const StyledButtonLogs = styled.button`
  background-color: #D8BFD8; /* Lavanda claro */
  border-radius: 100px;
  box-shadow: 
    rgba(216, 191, 216, 0.2) 0 -25px 18px -14px inset,
    rgba(216, 191, 216, 0.15) 0 1px 2px,
    rgba(216, 191, 216, 0.15) 0 2px 4px,
    rgba(216, 191, 216, 0.15) 0 4px 8px,
    rgba(216, 191, 216, 0.15) 0 8px 16px,
    rgba(216, 191, 216, 0.15) 0 16px 32px;

  color: var(--text-on-accent);
  cursor: pointer;
  display: inline-block;
  font-family: CerebriSans-Regular, -apple-system, system-ui, Roboto, sans-serif;
  padding: 3px 5px;
  text-align: center;
  text-decoration: none;
  transition: all 250ms;
  border: 0;
  font-size: 10px;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  margin-left: 0px;
  width: 55px;
  height: 20px;

  :hover {
    box-shadow: 
      rgba(216, 191, 216, 0.35) 0 -25px 18px -14px inset,
      rgba(216, 191, 216, 0.35) 0 1px 2px,
      rgba(216, 191, 216, 0.35) 0 2px 4px,
      rgba(216, 191, 216, 0.35) 0 4px 8px,
      rgba(216, 191, 216, 0.35) 0 8px 16px,
      rgba(216, 191, 216, 0.35) 0 16px 32px;
    transform: scale(1.02);
  }

  @media screen and (max-width: 768px) {
    font-size: 10px;
  }
`;

export const StyledButtonCancelar = styled.button`
  background-color: #FFA07A;
  border-radius: 100px;
  box-shadow: 
    rgba(255, 160, 122, 0.2) 0 -25px 18px -14px inset,
    rgba(255, 160, 122, 0.15) 0 1px 2px,
    rgba(255, 160, 122, 0.15) 0 2px 4px,
    rgba(255, 160, 122, 0.15) 0 4px 8px,
    rgba(255, 160, 122, 0.15) 0 8px 16px,
    rgba(255, 160, 122, 0.15) 0 16px 32px;

  color: var(--text-on-accent);
  cursor: pointer;
  display: inline-block;
  font-family: CerebriSans-Regular, -apple-system, system-ui, Roboto, sans-serif;
  padding: 3px 5px;
  text-align: center;
  text-decoration: none;
  transition: all 250ms;
  border: 0;
  font-size: 10px;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  margin-left: 0px;
  width: 55px;
  height: 20px;

  :hover {
    box-shadow: 
      rgba(255, 160, 122, 0.35) 0 -25px 18px -14px inset,
      rgba(255, 160, 122, 0.35) 0 1px 2px,
      rgba(255, 160, 122, 0.35) 0 2px 4px,
      rgba(255, 160, 122, 0.35) 0 4px 8px,
      rgba(255, 160, 122, 0.35) 0 8px 16px,
      rgba(255, 160, 122, 0.35) 0 16px 32px;
    transform: scale(1.02);
  }

  @media screen and (max-width: 768px) {
    font-size: 10px;
  }
`;

export const StyledButtonDownload = styled.button`
  background-color: #7CFCB8; /* Verde claro, menos neon */
  border-radius: 100px;
  box-shadow: 
    rgba(124, 252, 184, 0.2) 0 -25px 18px -14px inset,
    rgba(124, 252, 184, 0.15) 0 1px 2px,
    rgba(124, 252, 184, 0.15) 0 2px 4px,
    rgba(124, 252, 184, 0.15) 0 4px 8px,
    rgba(124, 252, 184, 0.15) 0 8px 16px,
    rgba(124, 252, 184, 0.15) 0 16px 32px;

  color: var(--text-on-accent);
  cursor: pointer;
  display: inline-block;
  font-family: CerebriSans-Regular, -apple-system, system-ui, Roboto, sans-serif;
  padding: 3px 5px;
  text-align: center;
  text-decoration: none;
  transition: all 250ms;
  border: 0;
  font-size: 10px;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  margin-left: 0px;
  width: 55px;
  height: 20px;

  :hover {
    box-shadow: 
      rgba(124, 252, 184, 0.35) 0 -25px 18px -14px inset,
      rgba(124, 252, 184, 0.35) 0 1px 2px,
      rgba(124, 252, 184, 0.35) 0 2px 4px,
      rgba(124, 252, 184, 0.35) 0 4px 8px,
      rgba(124, 252, 184, 0.35) 0 8px 16px,
      rgba(124, 252, 184, 0.35) 0 16px 32px;
    transform: scale(1.02);
  }

  @media screen and (max-width: 768px) {
    font-size: 10px;
  }
`;

export const DocumentInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const DocumentActions = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
`;